"use client";
import Link from "next/link";
import { LuPlus, LuSettings, LuStore } from "react-icons/lu";

import { DIALOG, setDialog } from "@/components/app/dialogs/dialog-provider";
import { IsLoggedIn } from "@/components/shared/is-logged-in";
import { Button } from "@/components/ui/button";

type isActive = "manage" | "create" | "store" | null;

interface FeedSettingsHeaderProps {
  isActive?: isActive;
}

export const FeedSettingsHeader = ({ isActive }: FeedSettingsHeaderProps) => {
  return (
    <div
      className="
        flex flex-col items-start justify-between border-b border-border-light
        p-4
        sm:items-center
        md:flex-row
      "
    >
      <div
        className="
          mb-4 flex items-center gap-4 font-sans text-xl font-semibold
          md:mb-0
        "
      >
        {isActive === "manage"
          ? "Manage Feeds"
          : isActive === "create"
            ? "Create Feed"
            : "Feed Store"}
      </div>
      <IsLoggedIn>
        <div className="relative">
          <div
            className="
              flex items-center gap-2
              hover:text-muted-foreground
            "
          >
            {/*<Link href="/feed/customize">
              <Button
                size="sm"
                variant={isActive === "manage" ? "default" : "outline"}
                className="flex items-center gap-2"
              >
                <LuSettings />
                Manage
              </Button>
            </Link>*/}
            <Button
              size="sm"
              variant={isActive === "manage" ? "default" : "outline"}
              className="flex items-center gap-2"
              onClick={() => {
                setDialog(DIALOG.FeedSettingsComingSoon, {
                  open: true,
                  historyMode: "entry",
                });
              }}
            >
              <LuSettings />
              Manage
            </Button>
            {/*<Link href="/feed/create">
            <Button
              size="sm"
              variant={isActive === "create" ? "default" : "outline"}
              className="flex items-center gap-2"
            >
              <LuPlus />
              Create
            </Button>
          </Link>*/}
            <Button
              size="sm"
              variant={isActive === "create" ? "default" : "outline"}
              className="flex items-center gap-2"
              onClick={() => {
                setDialog(DIALOG.FeedSettingsComingSoon, {
                  open: true,
                  historyMode: "entry",
                });
              }}
            >
              <LuPlus />
              Create
            </Button>
            <Link href="/feed/store">
              <Button
                size="sm"
                variant={isActive === "store" ? "default" : "outline"}
                className="flex items-center gap-2"
              >
                <LuStore />
                Feed Store
              </Button>
            </Link>
          </div>
        </div>
      </IsLoggedIn>
    </div>
  );
};
